import { render, staticRenderFns } from "./ActionDefaultLayout.vue?vue&type=template&id=5b174435&scoped=true"
import script from "./ActionDefaultLayout.vue?vue&type=script&lang=js"
export * from "./ActionDefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./ActionDefaultLayout.vue?vue&type=style&index=0&id=5b174435&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b174435",
  null
  
)

export default component.exports